import React from 'react';
import ueber_mich from './assets/ueber_mich/Uwe_Veronik_Anzug.webp';
import { useLanguage } from './LanguageContext';
import OptimizedImage from './components/OptimizedImage';

const About = () => {
  const { t } = useLanguage();

  const containerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    paddingRight: '1rem',
    fontFamily: 'Sora, sans-serif',
  };

  const contentStyle = {
    flex: '1',
    paddingLeft: '20px',
    textAlign: 'center',
    paddingBlock: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const headingStyle1 = {
    color: '#666666',
    fontWeight: '500',
    lineHeight: '1.1',
    letterSpacing: '-1px',
    fontSize: '1.8rem',
    marginBottom: '0.5rem',
    textAlign: 'center',
    fontFamily: 'Sora, sans-serif',
  };

  const headingStyle2 = {
    color: '#666666',
    fontWeight: '300',
    lineHeight: '1.1',
    letterSpacing: '-1px',
    fontSize: '1.2rem',
    marginBottom: '1rem',
    textAlign: 'center',
    fontFamily: 'Sora, sans-serif',
  };

  const imageStyle = {
    width: '200px',
    borderRadius: '5px',
    margin: '1.5rem 0',
  };

  const textStyle = {
    color: '#666666',
    lineHeight: '1.6',
    fontWeight: '300',
    fontSize: '1rem',
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Sora, sans-serif',
  };

  return (
    <section id="ueber-mich" style={{ padding: '1rem' }}>
      <style>{`
        .about-titles {
          width: 100%;
          text-align: center;
          margin-bottom: 1rem;
        }
        .about-layout {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
        .about-text {
          width: 100%;
        }
        .about-image {
          width: 200px;
          border-radius: 5px;
          margin: 1.5rem 0;
        }
        @media (min-width: 700px) {
          .about-titles {
            width: 100%;
            text-align: center;
            margin-bottom: 1.5rem;
          }
          .about-layout {
            flex-direction: row;
            align-items: stretch;
            justify-content: center;
            gap: 40px;
            width: 100%;
          }
          .about-text {
            flex: 1 1 0;
            max-width: 800px;
            text-align: left;
            margin: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          }
          .about-image {
            width: 200px;
            min-width: 200px;
            max-width: 200px;
            height: 100%;
            margin: 0;
            border-radius: 5px;
            align-self: stretch;
            object-fit: cover;
            display: block;
          }
        }
      `}</style>
      <div className="about-titles">
        <h1 style={headingStyle1}>{t('about')}</h1>
        <h2 style={headingStyle2}>{t('qualification')}</h2>
      </div>
      <div className="about-layout">
        <div className="about-text">
          <p style={textStyle}>
            {t('aboutText')}
          </p>
        </div>
        <OptimizedImage src={ueber_mich} alt="Uwe Veronik" className="about-image" />
      </div>
    </section>
  );
};

export default About; 